import {
	Message
} from 'element-ui';
import axios from 'axios';
import qs from 'qs'
import Router from '../../router/index.js'

// axios.defaults.timeout = 20000;
if (process.env.NODE_ENV === 'development') {
	axios.defaults.baseURL = '';// 本地 dev：走 webpack proxy -> back-nest (5860)
} else if (Object.prototype.hasOwnProperty.call(process.env, 'API_BASE_URL')) {
	axios.defaults.baseURL = process.env.API_BASE_URL;// Docker：空字符串 = 同域 nginx 反代
} else {
	axios.defaults.baseURL = 'https://guanli.halomu.com';// 生产环境
}

axios.defaults.withCredentials = true
//http request 拦截器
axios.interceptors.request.use(
	config => {
		let token = ''
		const collToken = sessionStorage.getItem('token')
		if (collToken) {
			token = collToken
		} else if (localStorage.getItem('userInfo')) {
			token = JSON.parse(localStorage.getItem('userInfo')).token
		}
		config.params.token = token
		if (config.data) {
			if (Object.prototype.toString.call(config.data) === '[object FormData]' && config.data.get('file')) {
				config.withCredentials = false
			}
		}
		// const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
		if (config.method == 'post' && JSON.stringify(config.data) != '{}') {
			config.data = qs.stringify(config.data);
		}

		config.headers = {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
		return config;
	},
	error => {
		return Promise.reject(err);
	}
);


//http response 拦截器
axios.interceptors.response.use(
	response => {
		if (response.data.code) {
			if (response.data.code == 401) {
				localStorage.clear()
				Router.replace({
					path: "/",
					query: {
						redirect: Router.history.current.fullPath
					} //从哪个页面跳转
				})
			} else if (response.data.code != 1) {
				Message({
					message: response.data.msg,
					type: 'warning',
					duration: 1500,
					center: !0
				})
			}
		} else if (response.data.code == 0) {
			Message({
				message: response.data.msg,
				type: 'warning',
				duration: 1500,
				center: !0
			})
		}
		return response;
	},
	error => {
		if (error.response.data.code == 401) {
			Message({
				message: '登录过期，请重新登录',
				type: 'warning',
				duration: 1500,
				center: !0,
				onClose() {
					Router.replace({
						path: "/",
						query: {
							redirect: Router.history.current.fullPath
						} //从哪个页面跳转
					})
				}
			})
		} else {
			return Promise.reject(error)
		}
	}
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(response => {
				resolve(response.data);
			})
			.catch(err => {
				let msg = err.msg && err.msg != '' ? err.msg : '网络不稳定，请刷新重试'
				Message({
					message: msg,
					type: 'warning',
					duration: 1500,
					center: !0
				})
				reject(err)
			})
	})
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, data, {
				params: {}
			})
			.then(response => {
				resolve(response.data);
			}, err => {
				let msg = err.msg && err.msg != '' ? err.msg : '网络不稳定，请刷新重试'
				Message({
					message: msg,
					type: 'warning',
					duration: 1500,
					center: !0
				})
				reject(err);
			})
	})
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.patch(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.put(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}
